/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { MultiSelectDropDown } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ EMBED : CONTROLBAR : CONTENT INDICATOR SORT ~~~~~~~~~~ ========== */
const ContentIndicatorSort = (props) => {
    return (
        <MultiSelectDropDown
        	name={'Embed State'}
        	title={'All States'}
			button={!!props.buttonAction}
			buttonAction={props.buttonAction}
			disabled={props.disabled}
        	icon={`power-off`}
        	onSelect={props.handleSelect}
        	items={props.allStatus}
        	selectedItems={props.status}
        />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ContentIndicatorSort;
